import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    ReferenceField,
    SelectField,
    CardActions,
    CreateButton,
    useListContext
} from 'react-admin';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import HealthcareActionButton from "../component/HealthcareActionButton";
import DivisionActionButton from "../component/DivisionActionButton";

const HealthcareServiceActions = ({
                                    bulkActions,
                                    basePath,
                                    currentSort,
                                    displayedFilters,
                                    exporter,
                                    filters,
                                    filterValues,
                                    onUnselectItems,
                                    resource,
                                    selectedIds,
                                    showFilter,
                                    total
                                }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        <CreateButton basePath={basePath} label={"Додати"} />
    </CardActions>
);


const Empty = () => {
    const { basePath } = useListContext();
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                Медичні послуги - відсутні
            </Typography>
            <CreateButton basePath={basePath} label="Додати" />
        </Box>
    );
};

export const HealthcareServiceList = (props) => (
    <List {...props}
          bulkActionButtons={false}
          perPage={25}
          title="Медичні послуги"
          actions={<HealthcareServiceActions />}
          className="list-styles"
          empty={<Empty />}
    >
        <Datagrid>
            <TextField sortable={false} label="ID" source="id" />
            <ReferenceField sortable={false} label="Аптека" source="divisionId" reference="divisions">
                <TextField source="name" />
            </ReferenceField>
            <SelectField label="Категорія" source="category" choices={[
                { id: 'MSP', name: 'Господарська діяльність з медичної практики' },
                { id: 'PHARMACY', name: 'Господарська діяльність з роздрібної торгівлі лікарськими засобами' },
                { id: 'PHARMACY_DRUGS', name: 'Господарська діяльність з обігу наркотичних засобів, психотропних речовин і прекурсорів' }
            ]} />
            <SelectField label="Тип" source="type" choices={[
                { id: 'ACQUISITION', name: 'Придбання наркотичних засобів, психотропних речовин і прекурсорів' },
                { id: 'PRODUCTION', name: 'Виробництво наркотичних засобів, психотропних речовин і прекурсорів' },
                { id: 'SALE', name: 'Реалізація (відпуск) наркотичних засобів, психотропних речовин і прекурсорів' },
                { id: 'STORAGE', name: 'Зберігання наркотичних засобів, психотропних речовин і прекурсорів' },
                { id: 'USE', name: 'Використання наркотичних засобів, психотропних речовин і прекурсорів' }
            ]} />
            <ReferenceField sortable={false} label="Ліцензія (номер наказу)" source="licenseId" reference="licenses">
                <TextField source="orderNo" />
            </ReferenceField>
            <HealthcareActionButton />
        </Datagrid>
    </List>
);

export default HealthcareServiceList;
